<script setup lang="ts">
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { primaryNavigation } from "@/content/pages";

const open = ref(false);
const menuButton = ref<HTMLButtonElement | null>(null);
const route = useRoute();
watch(() => route.fullPath, () => { open.value = false; });
function closeMenu() {
  if (!open.value) return;
  open.value = false;
  menuButton.value?.focus();
}
</script>

<template>
  <header class="site-header" @keydown.esc="closeMenu">
    <div class="header-inner">
      <RouterLink to="/" class="brand" aria-label="MySimpleBible home">
        <img src="/media/app-icon.svg" alt="" width="40" height="40" />
        <span>MySimple<wbr />Bible</span>
      </RouterLink>
      <nav class="desktop-nav" aria-label="Primary navigation">
        <RouterLink v-for="item in primaryNavigation" :key="item.path" :to="item.path" active-class="is-active">
          {{ item.label }}
        </RouterLink>
      </nav>
      <RouterLink to="/download/" class="header-cta">Download <span aria-hidden="true">↗</span></RouterLink>
      <button ref="menuButton" type="button" class="menu-button" :aria-expanded="open"
        aria-controls="mobile-menu" :aria-label="open ? 'Close navigation' : 'Open navigation'" @click="open = !open">
        <span>{{ open ? "Close" : "Menu" }}</span><span aria-hidden="true">{{ open ? "×" : "☰" }}</span>
      </button>
    </div>
    <nav v-if="open" id="mobile-menu" class="mobile-nav" aria-label="Mobile navigation">
      <RouterLink v-for="item in primaryNavigation" :key="item.path" :to="item.path" active-class="is-active">
        {{ item.label }} <span aria-hidden="true">↗</span>
      </RouterLink>
      <RouterLink to="/download/" class="mobile-cta">Download <span aria-hidden="true">↗</span></RouterLink>
    </nav>
  </header>
</template>
